import React, { useState, useEffect } from 'react'
import { Menu } from 'antd'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import getMenu from './constants'
import { actionCreators } from 'store'
import './style.scss'

function AppMenu(props) {
  const { menuCollapsed, setBreadcrumb, loginUser } = props
  const [defaultSelected, setDefaultSelected] = useState([])
  const [defaultOpen, setDefaultOpen] = useState([])
  const [openKeys, setOpenKeys] = useState([])
  const [menuList, setMenuList] = useState([])

  useEffect(() => {
    setMenuList(getMenu(loginUser.villageId))
  }, [loginUser])

  useEffect(() => {
    const { pathname } = props.location
    // 根据url获取当前应该展开和选中的菜单
    let probableParentMenu = null
    const getActiveKey = (menuList, path, parentKey) => {
      for (const menu of menuList) {
        if (menu.path === path) {
          return { key: menu.key, label: menu.label, parentKey }
        }
        if (path.indexOf(menu.path) > -1) {
          if (!probableParentMenu || probableParentMenu.path.length < menu.path.length) {
            probableParentMenu = { key: menu.key, label: menu.label, parentKey, path: menu.path }
          }
        }
        if (menu.children) {
          const selected = getActiveKey(menu.children, path, menu.key)
          if (selected) {
            return selected
          }
        }
      }
      return false
    }
    // 获取选中和展开的菜单
    const selectedMenu = getActiveKey(menuList, pathname, 'device') || probableParentMenu
    const cachedActiveMenu = JSON.parse(sessionStorage.getItem('netbox-active-menu') || '{}')
    let key = cachedActiveMenu.key || 'device-list' // 默认选中菜单项(一级或二级菜单)
    let openKey = cachedActiveMenu.openKey || 'device' // 默认展开菜单(一级菜单)
    if (selectedMenu) {
      key = selectedMenu.key
      openKey = selectedMenu.parentKey
      setBreadcrumb(selectedMenu.label)
      sessionStorage.setItem('netbox-active-menu', JSON.stringify({ openKey, key }))
    }
    setDefaultOpen([openKey])
    setDefaultSelected([key])
    if (openKeys.indexOf(openKey) === -1) {
      setOpenKeys([openKey])
    }
  }, [props.location.pathname, menuList])

  const onMenuClick = menu => {
    const routePath = menu.item.props.path
    props.history.push(routePath)
  }

  const onMenuChange = keys => {
    const lastOpenKey = keys.find(key => openKeys.indexOf(key) === -1)
    if (!menuList.find(menu => menu.key === lastOpenKey)) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(lastOpenKey ? [lastOpenKey] : [])
    }
  }

  return (
    <div className={menuCollapsed ? 'app-menu' : 'app-menu app-menu--collapsed'}>
      {defaultSelected.length > 0 && defaultOpen.length > 0 && (
        <Menu
          defaultSelectedKeys={defaultSelected}
          defaultOpenKeys={defaultOpen}
          selectedKeys={defaultSelected}
          // openKeys={openKeys}
          mode="inline"
          theme="dark"
          inlineCollapsed={menuCollapsed}
          onClick={onMenuClick}
          style={{
            background: '#343956',
            color: '#bcbcc6',
            height: '100%',
            paddingTop: '10px'
          }}
          // onOpenChange={onMenuChange} 暂时全部展开
        >
          <header className={menuCollapsed ? 'header header-collapsed' : 'header'}>
            {/*<div className="header-logo">*/}
            {/*  /!*<img src={require('../../assets/images/logo.png')} alt="码上说事"/>*!/*/}
            {/*</div>*/}
            {!menuCollapsed && (
              <div className="header-text">东钱湖书记一点通</div>
            )}
          </header>
          {menuList.map(menu => {
            if (menu.hide) return ''
            return menu.children
              ? (
                <Menu.SubMenu
                  key={menu.key}
                  title={
                    <span>
                      {menu.icon}
                      <span>{menu.label}</span>
                    </span>
                  }
                >
                  {menu.children.map(sub => {
                    return (
                      !sub.hide ? (
                        <Menu.Item key={sub.key} path={sub.path}>
                          {sub.label}
                        </Menu.Item>
                      ) : (
                        ''
                      )
                    )
                  })}
                </Menu.SubMenu>
              ) : (
                !menu.hide ? (
                  <Menu.Item key={menu.key} path={menu.path}>
                    {menu.icon}
                    <span>{menu.label}</span>
                  </Menu.Item>
                ) : ''
              )
          })}
        </Menu>
      )}
    </div>
  )
}

export default connect(state => ({
  menuCollapsed: state.getIn(['common', 'menuCollapsed']),
  loginUser: state.getIn(['common', 'loginUser']),
  personalize: state.getIn(['common', 'personalize'])
}), dispatch => ({
  setBreadcrumb(value) {
    dispatch(actionCreators.setBreadcrumb(value))
  }
}))(withRouter(AppMenu))
